// --- Headers & Filters for Data Table ---
// Since we set `must-sort` in v-data-table-server, this `sortable: true` is optional
const headers = [
  { title: 'Nama', key: 'name', sortable: true },
  { title: 'Email', key: 'email', sortable: true },
  { title: 'Roles', key: 'roles', sortable: false },
  { title: 'Created At', key: 'created_at', sortable: true },
  { title: 'Updated At', key: 'updated_at', sortable: true },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
];

const filters = [
  { title: 'Nama', key: 'name', type: 'text' },
  { title: 'Email', key: 'email', type: 'text' },
  { title: 'Roles', key: 'roles', type: 'text' },
];

export { filters, headers };

// Notes
// - `filterKey` is used when the key in the data object is different from the filter field name
// - `filterType` can be 'text', 'select', 'date', etc., depending on the filter component used in the data table
// - `align` can be 'start', 'center', or 'end' to align the content in the column

// - If you only want the first role name, use { key: 'roles[0].name', filterKey: 'roles' }
// - Roles column is not sortable in this case due to the complexity of sorting nested arrays/collections on the server side (due to relationships)
// - Actions column is not sortable and centered for better UI/UX
